import Vue from 'vue'
import Router from 'vue-router'
import carship from './carship'
import business from './business' // 万知商务导航路由表
import businessPersonCenter from './businessPersonCenter' // 个人中心-万知商务导航路由表(用户)
import businessSellerCenter from './businessPersonCenterSeller'// 个人中心-万知商务导航路由表(商户)
import teacher from './teacher' // 导入教师路由模块

const Index = () => import('@/components/Index')
const Search = () => import('@/components/Search')

// 登录注册忘记密码路由
const Login = () => import('@/components/Login')
const LoginContent = () => import('@/components/login/Login')
const RegisterContent = () => import('@/components/login/Register')
const ForgetPwdContent = () => import('@/components/ForgetPwd')

// 天地图H5
const TiandituH5 = () => import('@/components/TiandituH5')

// 旅游页路由
const Tour = () => import('@/components/Tour')
const TourList = () => import('@/components/tour/TourList')
const TourDetail = () => import('@/components/tour/TourDetail')

// 市场页路由
const Market = () => import('@/components/Market')
const MarketList = () => import('@/components/market/MarketList')
const MarketDetail = () => import('@/components/market/MarketDetail')

// 教育页路由
const Teacher = () => import('@/components/Teacher')
const Education = () => import('@/components/Education')
const EducationList = () => import('@/components/education/EducationList')
const EducationDetail1 = () => import('@/components/education/EducationDetail1')
const EducationDetail2 = () => import('@/components/education/EducationDetail2')
const EducationDetail3 = () => import('@/components/education/EducationDetail3')
const FengcaiList = () => import('@/components/education/FengcaiList')
const XiaoyouList = () => import('@/components/education/XiaoyouList')
const XiaoyouDeatil = () => import('@/components/education/XiaoyouDeatil')
const SchoolLifeList = () => import('@/components/education/SchoolLifeList')
const SchoolLifeDeatil = () => import('@/components/education/SchoolLifeDeatil')
const GonggaoList = () => import('@/components/education/GonggaoList')
const GonggaoDeatil = () => import('@/components/education/GonggaoDeatil')
const KewuList = () => import('@/components/education/KewuList')
const KewuDeatil = () => import('@/components/education/KewuDeatil')
const KejianList = () => import('@/components/education/KejianList')
const KejianDeatil = () => import('@/components/education/KejianDeatil')

// 我的页路由
const Own = () => import('@/components/Own')
const OwnList = () => import('@/components/own/OwnList')
const OwnDetail1 = () => import('@/components/own/OwnDetail1')
const OwnDetail2 = () => import('@/components/own/OwnDetail2')

// 信息页路由
const Information = () => import('@/components/Information')
const InformationList = () => import('@/components/information/InformationList')
const InformationDetail = () => import('@/components/information/InformationDetail')

// 人才页路由
const Talents = () => import('@/components/Talents')
const TalentsList = () => import('@/components/talents/TalentsList')
const TalentsDetail1 = () => import('@/components/talents/TalentsDetail1')
const TalentsDetail2 = () => import('@/components/talents/TalentsDetail2')
const TalentsDetail3 = () => import('@/components/talents/TalentsDetail3')

// 生活页路由
const Live = () => import('@/components/Live')
const LiveList = () => import('@/components/live/LiveList')
const LiveDetail1 = () => import('@/components/live/LiveDetail1')

// 支付
const Pay = () => import('@/components/Pay')
const PayOne = () => import('@/components/pay/PayOne')
const PayTwo = () => import('@/components/pay/PayTwo')

// 个人中心路由
const User = () => import('@/components/User')
const TourRelease = () => import('@/components/user/tour/Tour')
const UserTourBase = () => import('@/components/user/tour/Base')
const UserTourDetail = () => import('@/components/user/tour/Detail')
const UserTourTheme = () => import('@/components/user/tour/Theme')
const UserTourIntroduce = () => import('@/components/user/tour/Introduce')
const UserTourReceivedMessage = () => import('@/components/user/tour/ReceivedMessage')
const UserTourSendMessage = () => import('@/components/user/tour/SendMessage')
const ThreePicScenery = () => import('@/components/user/tour/ThreePicScenery')
const Futi = () => import('@/components/user/tour/Futi')
const Tietu = () => import('@/components/user/tour/Tietu')
const Zhuzhi = () => import('@/components/user/tour/Zhuzhi')
const ViewVR = () => import('@/components/user/tour/ViewVR')

// 个人中心--市场
const MarketRelease = () => import('@/components/user/market/Market')
const UserMarketBase = () => import('@/components/user/market/Base')
const UserMarketDetail = () => import('@/components/user/market/Detail')
const UserMarketGoods = () => import('@/components/user/market/Goods')
const UserMarketInformation = () => import('@/components/user/market/Information')
const UserMarketLeavemess = () => import('@/components/user/market/Leavemess')
const UserMarketAttention = () => import('@/components/user/market/Attention')
const UserMarketNotice = () => import('@/components/user/market/Notice')
const UserMarketSettled = () => import('@/components/user/market/Settled')
const UserMarketWanderer = () => import('@/components/user/market/Wanderer')
const UserMarketPersonnel = () => import('@/components/user/market/Personnel')

// 个人中心--教育
const EducationRelease = () => import('@/components/user/education/Education')
const UserEducationBase = () => import('@/components/user/education/Base')
const UserEducationDetail = () => import('@/components/user/education/Detail')
const UserEducationZuzhiList = () => import('@/components/user/education/Zuzhi')
const UserEducationInformation = () => import('@/components/user/education/Information')
const UserEducationXiaoyou = () => import('@/components/user/education/xiaoyou')
const UserEducationTeach = () => import('@/components/user/education/teach')
const UserEducationKewu = () => import('@/components/user/education/kewu')
const UserEducationKejian = () => import('@/components/user/education/kejian')
const UserEducationOrder = () => import('@/components/user/education/order')
const UserEducationCode = () => import('@/components/user/education/code')
const UserEducationUserOrder = () => import('@/components/user/education/userOrder')

// 个人中心--人才
const TalentsRelease = () => import('@/components/user/talents/Talents')
const UserTalentsBase = () => import('@/components/user/talents/Base')
const UserTalentsDetail = () => import('@/components/user/talents/Detail')
const UserTalentsExperienceList = () => import('@/components/user/talents/Experience')
const UserTalentsPosition = () => import('@/components/user/talents/Position')
const UserTalentsReceiveResume = () => import('@/components/user/talents/ReceiveResume')
const UserTalentsSendResume = () => import('@/components/user/talents/sendResume')
const UserTalentsInvitInterview = () => import('@/components/user/talents/invitInterview')
const UserTalentsInvitInterview2 = () => import('@/components/user/talents/invitInterview2')

// 个人中心--相爱
const mutuaLovelist = () => import('@/components/user/mutualLove/list')
const Personalinfo = () => import('@/components/user/mutualLove/Personalinfo')
const AttentionList = () => import('@/components/user/mutualLove/AttentionList')
const ScreenList = () => import('@/components/user/mutualLove/ScreenList')
const LinkList = () => import('@/components/user/mutualLove/LinkList')
const loverinfo = () => import('@/components/user/mutualLove/loverinfo')
const GiftOrder = () => import('@/components/user/mutualLove/GiftOrder')
const MyGifts = () => import('@/components/user/mutualLove/MyGifts')
const GiftList = () => import('@/components/user/mutualLove/GiftList')
const setingIntroducer = () => import('@/components/user/mutualLove/setingIntroducer')
const Introducerinfot = () => import('@/components/user/mutualLove/Introducer/Introducerinfot')
const Introducerlist = () => import('@/components/user/mutualLove/Introducer/Introducerlist')
const Introducerinfo1 = () => import('@/components/user/mutualLove/Introducer/Introducerinfo1')
const Introducerinfo2 = () => import('@/components/user/mutualLove/Introducer/Introducerinfo2')
const Introducerinfo3 = () => import('@/components/user/mutualLove/Introducer/Introducerinfo3')
const Introducerinfo4 = () => import('@/components/user/mutualLove/Introducer/Introducerinfo4')

// 个人中心--生活
const LiveRelease = () => import('@/components/user/live/Live')
const UserLiveBase = () => import('@/components/user/live/Base')
const UserLiveInfo = () => import('@/components/user/live/LiveInfo')
const UserNeedInfo = () => import('@/components/user/live/NeedInfo')
const UserLiveReceiveResume = () => import('@/components/user/live/ReceiveResume')
const UserLiveSendResume = () => import('@/components/user/live/sendResume')

// 个人中心--我的
const OwnRelease = () => import('@/components/user/own/Own')
const UserOwnBase = () => import('@/components/user/own/Base')
const UserOwnDetail = () => import('@/components/user/own/Detail')
const UserOwnReceivedMessage = () => import('@/components/user/own/ReceivedMessage')
const UserOwnSendMessage = () => import('@/components/user/own/SendMessage')
const UserOwnComment = () => import('@/components/user/own/Comment')
const UserOwnReport = () => import('@/components/user/own/Report')
const UserOwnInfoList = () => import('@/components/user/own/infoList')

// 个人中心--信息
const InformationRelease = () => import('@/components/user/information/Information')
const UserInformationBase = () => import('@/components/user/information/Base')
const UserInformationSerive = () => import('@/components/user/information/service')
const UserInformationModuleList = () => import('@/components/user/information/moduleList')
const UserInformationReceivedMessage = () => import('@/components/user/information/ReceivedMessage')
const UserInformationSendMessage = () => import('@/components/user/information/SendMessage')
const UserInformationComment = () => import('@/components/user/information/Comment')
const UserInformationReport = () => import('@/components/user/information/Report')
const UserInformationInfoList = () => import('@/components/user/information/infoList')

// 个人中心--相同
const SameRelease = () => import('@/components/user/same/Same')
const UserSameBase = () => import('@/components/user/same/Base')
const UserSameTongzhu = () => import('@/components/user/same/Tongzhu')
const UserSameTongzhuList = () => import('@/components/user/same/TongzhuList')
const UserSameTongzhuMemberList = () => import('@/components/user/same/MemberList')
const UserSameZhiwenList = () => import('@/components/user/same/ZhiwenList')
const UserSameYitiList = () => import('@/components/user/same/YitiList')
const UserSameTiyiList = () => import('@/components/user/same/TiyiList')
const UserSameYitiDetail = () => import('@/components/user/same/YitiDetail')
const UserSameJianjie = () => import('@/components/user/same/Jianjie')
const UserSameInfoList = () => import('@/components/user/same/InfoList')
const UserSameInfoDetail = () => import('@/components/user/same/InfoDetail')
const UserSameTiebaList = () => import('@/components/user/same/TiebaList')
const UserSameTiebaDetail = () => import('@/components/user/same/TiebaDetail')
const UserSameTongguan = () => import('@/components/user/same/Tongguan')
const UserSameTongyuan = () => import('@/components/user/same/Tongyuan')
const UserSameZuoke = () => import('@/components/user/same/Zuoke')
const UserSameZuokeBase = () => import('@/components/user/same/ZuokeBase')
const UserSameZuokeList = () => import('@/components/user/same/ZuokeList')
const UserSameZuokeHuida = () => import('@/components/user/same/ZuokeHuida')

// 发布路由
const Release = () => import('@/components/Release')
const ReleaseTour = () => import('@/components/release/Tour')
const ReleaseMarket = () => import('@/components/release/Market')
const ReleaseEducation = () => import('@/components/release/Education')
const ReleaseTalents = () => import('@/components/release/Talents')
const ReleaseLive = () => import('@/components/release/Live')
const ReleaseOwn = () => import('@/components/release/Own')
const ReleaseInformation = () => import('@/components/release/Information')
const ReleaseInformationEdit = () => import('@/components/release/InformationEdit')

// 个人信息
const PersonInfo = () => import('@/components/user/person/Person')
const PersonInfoBase = () => import('@/components/user/person/Base')
const ChangePassword = () => import('@/components/user/person/ChangePassword')
const ChildernAccount = () => import('@/components/user/person/ChildernAccount')
const CartManage = () => import('@/components/user/person/CartManage')
const CartOrder = () => import('@/components/user/person/CartOrder')


// 相爱
const Love = () => import('@/components/mutualLove/MutualLoveHome')
const MembershipDetails = () => import('@/components/mutualLove/MembershipDetails')
const Introducerinfo = () => import('@/components/mutualLove/Introducerinfo')
const Introducerinfogeren = () => import('@/components/mutualLove/Introducerinfogeren')

// register注册界面
const register = () => import('@/components/register/register')

// 支付页面
const payment = () => import('@/components/payment/payment')

// 房产
const House = () => import('@/components/House')
const HouseIndex = () => import('@/components/house/HouseIndex')
const HouseDetail = () => import('@/components/house/HouseDetail')
const HuxingDetail = () => import('@/components/house/HuxingDetail')
const UserHouse = () => import('@/components/user/house/UserHouse')
const UserHouseList = () => import('@/components/user/house/UserHouseList')
const UserHouseEdit = () => import('@/components/user/house/UserHouseEdit')

// 闲置
const Idle = () => import('@/components/Idle')
const IdleIndex = () => import('@/components/idle/IdleIndex')
const IdleDetail = () => import('@/components/idle/IdleDetail')
const UserIdle = () => import('@/components/user/idle/UserIdle')
const UserIdleList = () => import('@/components/user/idle/UserIdleList')
const UserIdleEdit = () => import('@/components/user/idle/UserIdleEdit')

// 车
const UserCar = () => import('@/components/user/car/UserCar')
const UserCarList = () => import('@/components/user/car/UserCarList')
const UserCarEdit = () => import('@/components/user/car/UserCarEdit')

// 船
const UserShip = () => import('@/components/user/ship/UserShip')
const UserShipList = () => import('@/components/user/ship/UserShipList')
const UserShipEdit = () => import('@/components/user/ship/UserShipEdit')

// 物流
const Logistics = () => import('@/components/Logistics')
const LogisticsIndex = () => import('@/components/logistics/LogisticsIndex')
const LogisticsDetail = () => import('@/components/logistics/LogisticsDetail')
const LogisticsUser = () => import('@/components/logistics/LogisticsUser')
const UserLogistics = () => import('@/components/user/logistics/UserLogistics')
const UserLogisticsList = () => import('@/components/user/logistics/UserLogisticsList')
const UserLogisticsEdit = () => import('@/components/user/logistics/UserLogisticsEdit')

// 导航
const Navigation = () => import('@/components/Navigation')
const NavigationIndex = () => import('@/components/navigation/NavigationIndex')
const NavigationSite = () => import('@/components/navigation/NavigationSite')
const NavigationSearch = () => import('@/components/navigation/NavigationSearch')
const NavigationApply = () => import('@/components/navigation/NavigationApply')

// 相同
const Same = () => import('@/components/Same')
const SameIndex = () => import('@/components/Same/SameIndex')
const SameDetail = () => import('@/components/Same/SameDetail')
const SameDetailIndex = () => import('@/components/Same/SameDetailIndex')
const SameDetailYiti = () => import('@/components/Same/SameDetailYiti')
const SameDetailCommon = () => import('@/components/Same/SameDetailCommon')
const SameDetailZhiwen = () => import('@/components/Same/SameDetailZhiwen')
const SameApply = () => import('@/components/Same/sameApply')
const SameZhiwenApply = () => import('@/components/Same/SameZhiwenApply')
const SameZhiwenHuida = () => import('@/components/Same/SameZhiwenHuida')

// 404页面
const Page404 = () => import('@/components/Page404')

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        requireLogin: false,
        title: '【万知】万知万知，万万知，万知网里知万知；',
        content: {
          keywords: '教育，相爱，物流，人才，市场，闲置，车船，生活，旅游，我的，信息，相同，商务，导航',
          description: '万知网含盖教育、相爱、物流、人才、市场、闲置、房产、车船、生活、旅游、我的、信息、相同、商务、导航，发布老师课件，视频课件，学校，培训机构，婚恋 礼物 交友 招聘 人才 货源 送货 仓储 物流 配送 货车 市场 家具 服装 闲置 二手 回收 出售 新房 二手房 租房 求组 卖房 找房 楼盘 新车 二手车 租车 卖车 出售 买车 商店  便利店 超市  理发  酒店 宾馆 饭店 早餐 旅游 景点 美景 好玩  名山 乐园 农家乐 同学 同好 同地 同城 商品 网店 电商 好货 便宜 美食 日用 百货 饰品'
        }
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: {
        requireLogin: false,
        title: '万知搜索'
      }
    },
    {
      path: '/tour',
      name: 'Tour',
      component: Tour,
      redirect: '/tour/index',
      meta: {
        requireLogin: false,
        title: '万知旅游'
      },
      children: [
        {
          path: '/tour/index',
          name: 'TourList',
          component: TourList,
          meta: {
            title: '万知旅游'
          }
        },
        {
          path: '/tour/tour_detail',
          name: 'TourDetail',
          component: TourDetail,
          meta: {
            title: '万知详情'
          }
        }
      ]
    }, {
      path: '/education',
      name: 'Education',
      component: Teacher,
      redirect: '/education/index',
      meta: {
        requireLogin: false
      },
      children: [
        {
          path: '/education/index',
          name: 'EducationList',
          component: Teacher,
          meta: {
            title: '万知教育'
          }
        }
      ]
    // }, {
    //   path: '/education',
    //   name: 'Education',
    //   component: Education,
    //   redirect: '/education/index',
    //   meta: {
    //     requireLogin: false
    //   },
    //   children: [
    //     {
    //       path: '/education/index',
    //       name: 'EducationList',
    //       component: EducationList,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/education_detail1',
    //       name: 'EducationDetail1',
    //       component: EducationDetail1,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/education_detail2',
    //       name: 'EducationDetail2',
    //       component: EducationDetail2,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/education_detail3',
    //       name: 'EducationDetail3',
    //       component: EducationDetail3,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/fengcaiList',
    //       name: 'FengcaiList',
    //       component: FengcaiList,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/xiaoyouList',
    //       name: 'XiaoyouList',
    //       component: XiaoyouList,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/xiaoyouDeatil',
    //       name: 'XiaoyouDeatil',
    //       component: XiaoyouDeatil,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/schoolLifeList',
    //       name: 'SchoolLifeList',
    //       component: SchoolLifeList,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/schoolLifeDeatil',
    //       name: 'SchoolLifeDeatil',
    //       component: SchoolLifeDeatil,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/gonggaoList',
    //       name: 'GonggaoList',
    //       component: GonggaoList,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/gonggaoDeatil',
    //       name: 'GonggaoDeatil',
    //       component: GonggaoDeatil,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/kewuList',
    //       name: 'KewuList',
    //       component: KewuList,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/kewuDeatil',
    //       name: 'KewuDeatil',
    //       component: KewuDeatil,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/kejianList',
    //       name: 'KejianList',
    //       component: KejianList,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     },
    //     {
    //       path: '/education/kejianDeatil',
    //       name: 'KejianDeatil',
    //       component: KejianDeatil,
    //       meta: {
    //         title: '万知教育'
    //       }
    //     }
    //   ]
    }, {
      path: '/own',
      name: 'Own',
      component: Own,
      redirect: '/own/index',
      meta: {
        requireLogin: false
      },
      children: [
        {
          path: '/own/index',
          name: 'OwnList',
          component: OwnList,
          meta: {
            title: '万知之我'
          }
        },
        {
          path: '/own/own_detail1',
          name: 'OwnDetail1',
          component: OwnDetail1,
          meta: {
            title: '万知之我'
          }
        },
        {
          path: '/own/own_detail2',
          name: 'OwnDetail2',
          component: OwnDetail2,
          meta: {
            title: '万知之我'
          }
        }
      ]
    }, {
      path: '/information',
      name: 'Information',
      component: Information,
      redirect: '/information/index',
      meta: {
        requireLogin: false
      },
      children: [
        {
          path: '/information/index',
          name: 'InformationList',
          component: InformationList,
          meta: {
            title: '万知信息'
          }
        },
        {
          path: '/information/information_detail',
          name: 'InformationDetail',
          component: InformationDetail,
          meta: {
            title: '万知信息'
          }
        }
      ]
    },
    {
      path: '/daohang',
      name: 'Daohang',
      component: Navigation,
      redirect: '/daohang/index',
      meta: {
        requireLogin: false
      },
      children: [
        {
          path: '/daohang/index',
          name: 'DaohangIndex',
          component: NavigationIndex,
          meta: {
            title: '万知导航'
          }
        },
        {
          path: '/daohang/site',
          name: 'DaohangSite',
          component: NavigationSite,
          meta: {
            title: '万知导航'
          }
        },
        {
          path: '/daohang/search',
          name: 'DaohangSearch',
          component: NavigationSearch,
          meta: {
            title: '万知导航'
          }
        },
        {
          path: '/daohang/apply',
          name: 'DaohangApply',
          component: NavigationApply,
          meta: {
            title: '申请入驻',
            requireLogin: true
          }
        }
      ]
    },
    {
      path: '/same',
      name: 'Same',
      component: Same,
      redirect: '/same/index',
      meta: {
        requireLogin: false
      },
      children: [
        {
          path: '/same/index',
          name: 'SameIndex',
          component: SameIndex,
          meta: {
            title: '万知相同'
          }
        },
        {
          path: '/same/detail',
          name: 'SameDetail',
          component: SameDetail,
          meta: {
            title: '万知相同-详情'
          },
          children: [
            {
              path: '/same/detail/index',
              name: 'SameDetailIndex',
              component: SameDetailIndex,
              meta: {
                title: '万知相同-详情'
              }
            },
            {
              path: '/same/detail/yiti',
              name: 'SameDetailYiti',
              component: SameDetailYiti,
              meta: {
                title: '万知相同-议题详情'
              }
            },
            {
              path: '/same/detail/common',
              name: 'SameDetailCommon',
              component: SameDetailCommon,
              meta: {
                title: '万知相同-详情'
              }
            },
            {
              path: '/same/detail/zhiwen',
              name: 'SameDetailZhiwen',
              component: SameDetailZhiwen,
              meta: {
                title: '万知相同-知问详情'
              }
            }
          ]
        },
        {
          path: '/same/apply',
          name: 'SameApply',
          component: SameApply,
          meta: {
            title: '万知相同-申请入同',
            requireLogin: true
          }
        },
        {
          path: '/same/zhiwen-apply',
          name: 'SameZhiwenApply',
          component: SameZhiwenApply,
          meta: {
            title: '万知相同-申请做客知问',
            requireLogin: true
          }
        },
        {
          path: '/same/zhiwen-huida',
          name: 'SameZhiwenHuida',
          component: SameZhiwenHuida,
          meta: {
            title: '万知相同-知问应答',
            requireLogin: true
          }
        }
      ]
    },
    {
      path: '/talents',
      name: 'Talent',
      component: Talents,
      redirect: '/talents/index',
      meta: {
        requireLogin: false
      },
      children: [
        {
          path: '/talents/index',
          name: 'TalentsList',
          component: TalentsList,
          meta: {
            title: '万知人才'
          }
        },
        {
          path: '/talents/talents_detail1',
          name: 'TalentsDetail1',
          component: TalentsDetail1,
          meta: {
            title: '万知人才'
          }
        },
        {
          path: '/talents/talents_detail2',
          name: 'TalentsDetail2',
          component: TalentsDetail2,
          meta: {
            title: '万知人才'
          }
        },
        {
          path: '/talents/talents_detail3',
          name: 'TalentsDetail3',
          component: TalentsDetail3,
          meta: {
            title: '万知人才'
          }
        }
      ]
    }, {
      path: '/live',
      name: 'Live',
      component: Live,
      redirect: '/live/index',
      meta: {
        requireLogin: false
      },
      children: [
        {
          path: '/live/index',
          name: 'LiveList',
          component: LiveList,
          meta: {
            title: '万知生活'
          }
        },
        {
          path: '/live/Live_detail1',
          name: 'LiveDetail1',
          component: LiveDetail1,
          meta: {
            title: '万知生活'
          }
        }
      ]
    }, {
      path: '/market',
      name: 'Market',
      component: Market,
      redirect: '/market/index',
      meta: {
        requireLogin: false
      },
      children: [
        {
          path: '/market/index',
          name: 'MarketList',
          component: MarketList,
          meta: {
            title: '万知市场'
          }
        },
        {
          path: '/market/market_detail',
          name: 'MarketDetail',
          component: MarketDetail,
          meta: {
            title: '万知市场'
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      redirect: '/login/login',
      meta: {
        requireLogin: false
      },
      children: [{
        path: '/login/login',
        name: 'LoginContent',
        component: LoginContent,
        meta: {
          title: '登录页'
        }
      }, {
        path: '/login/register',
        name: 'RegisterContent',
        component: RegisterContent,
        meta: {
          title: '注册页'
        }
      }]
    },
    {
      path: '/pay',
      name: 'Pay',
      component: Pay,
      redirect: '/pay/pay',
      meta: {
        requireLogin: true
      },
      children: [{
        path: '/pay/pay',
        name: 'PayOne',
        component: PayOne,
        meta: {
          title: '支付页'
        }
      }, {
        path: '/pay/paytwo',
        name: 'PayTwo',
        component: PayTwo,
        meta: {
          title: '支付页'
        }
      }]
    },
    {
      path: '/login/ForgetPwd',
      name: 'ForgetPwdContent',
      component: ForgetPwdContent
    },
    {
      path: '/tiandituh5',
      name: 'tiandituh5',
      component: TiandituH5
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: {
        requireLogin: true
      },
      children: [{
        path: '/user/tourRelease',
        name: 'TourRelease',
        component: TourRelease,
        redirect: '/user/tourRelease/base',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/tourRelease/base',
          name: 'UserTourBase',
          component: UserTourBase
        },
        {
          path: '/user/tourRelease/detail',
          name: 'UserTourDetail',
          component: UserTourDetail
        },
        {
          path: '/user/tourRelease/theme',
          name: 'UserTourTheme',
          component: UserTourTheme
        },
        {
          path: '/user/tourRelease/introduce',
          name: 'UserTourIntroduce',
          component: UserTourIntroduce
        },
        {
          path: '/user/tourRelease/receivedMessage',
          name: 'UserTourReceivedMessage',
          component: UserTourReceivedMessage
        },
        {
          path: '/user/tourRelease/sendMessage',
          name: 'UserTourSendMessage',
          component: UserTourSendMessage
        },
        {
          path: '/user/tourRelease/threePicScenery',
          name: 'ThreePicScenery',
          component: ThreePicScenery
        },
        {
          path: '/user/tourRelease/futi',
          name: 'Futi',
          component: Futi
        },
        {
          path: '/user/tourRelease/tietu',
          name: 'Tietu',
          component: Tietu
        },
        {
          path: '/user/tourRelease/zhuzhi',
          name: 'Zhuzhi',
          component: Zhuzhi
        },
        {
          path: '/user/tourRelease/viewVR',
          name: 'ViewVR',
          component: ViewVR
        }
        ]
      },
      {
        path: '/user/mutuaLovelist',
        name: 'mutuaLovelist',
        component: mutuaLovelist,
        redirect: '/user/mutuaLovelist/Personalinfo',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/mutuaLovelist/Personalinfo',
          name: 'Personalinfo',
          component: Personalinfo
        },
        {
          path: '/user/mutuaLovelist/loverinfo',
          name: 'loverinfo',
          component: loverinfo
        },
        {
          path: '/user/mutuaLovelist/AttentionList',
          name: 'AttentionList',
          component: AttentionList
        },
        {
          path: '/user/mutuaLovelist/LinkList',
          name: 'LinkList',
          component: LinkList
        },
        {
          path: '/user/mutuaLovelist/ScreenList',
          name: 'ScreenList',
          component: ScreenList
        },
        {
          path: '/user/mutuaLovelist/GiftList',
          name: 'GiftList',
          component: GiftList
        },
        {
          path: '/user/mutuaLovelist/GiftOrder',
          name: 'GiftOrder',
          component: GiftOrder
        },
        {
          path: '/user/mutuaLovelist/MyGifts',
          name: 'MyGifts',
          component: MyGifts
        },
        {
          path: '/user/mutuaLovelist/setingIntroducer',
          name: 'setingIntroducer',
          component: setingIntroducer
        }]
      },
      {
        path: '/user/Introducerlist',
        name: 'Introducerlist',
        component: Introducerlist,
        redirect: '/user/Introducerlist/Introducerinfot',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/Introducerlist/Introducerinfot',
          name: 'Introducerinfot',
          component: Introducerinfot
        },
        {
          path: '/user/Introducerlist/Introducerinfo1',
          name: 'Introducerinfo1',
          component: Introducerinfo1
        },
        {
          path: '/user/Introducerlist/Introducerinfo2',
          name: 'Introducerinfo2',
          component: Introducerinfo2
        },
        {
          path: '/user/Introducerlist/Introducerinfo3',
          name: 'Introducerinfo3',
          component: Introducerinfo3
        },
        {
          path: '/user/Introducerlist/Introducerinfo4',
          name: 'Introducerinfo4',
          component: Introducerinfo4
        }]
      },
      {
        path: '/user/marketRelease',
        name: 'MarketRelease',
        component: MarketRelease,
        redirect: '/user/marketRelease/base',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/marketRelease/base',
          name: 'UserMarketBase',
          component: UserMarketBase
        },
        {
          path: '/user/marketRelease/detail',
          name: 'UserMarketDetail',
          component: UserMarketDetail
        },
        {
          path: '/user/marketRelease/goods',
          name: 'UserMarketGoods',
          component: UserMarketGoods
        },
        {
          path: '/user/marketRelease/information',
          name: 'UserMarketInformation',
          component: UserMarketInformation
        },
        {
          path: '/user/marketRelease/leavemess',
          name: 'UserMarketLeavemess',
          component: UserMarketLeavemess
        },
        {
          path: '/user/marketRelease/attention',
          name: 'UserMarketAttention',
          component: UserMarketAttention
        },
        {
          path: '/user/marketRelease/notice',
          name: 'UserMarketNotice',
          component: UserMarketNotice
        },
        {
          path: '/user/marketRelease/settled',
          name: 'UserMarketSettled',
          component: UserMarketSettled
        },
        {
          path: '/user/marketRelease/wanderer',
          name: 'UserMarketWanderer',
          component: UserMarketWanderer
        },
        {
          path: '/user/marketRelease/personnel',
          name: 'UserMarketPersonnel',
          component: UserMarketPersonnel
        }]
      }, {
        path: '/user/educationRelease',
        name: 'EducationRelease',
        component: EducationRelease,
        redirect: '/user/educationRelease/base',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/educationRelease/base',
          name: 'UserEducationBase',
          component: UserEducationBase
        },
        {
          path: '/user/educationRelease/detail',
          name: 'UserEducationDetail',
          component: UserEducationDetail
        },
        {
          path: '/user/educationRelease/zuzhi',
          name: 'UserEducationZuzhiList',
          component: UserEducationZuzhiList
        },
        {
          path: '/user/educationRelease/information',
          name: 'UserEducationInformation',
          component: UserEducationInformation
        },
        {
          path: '/user/educationRelease/xiaoyou',
          name: 'UserEducationXiaoyou',
          component: UserEducationXiaoyou
        },
        {
          path: '/user/educationRelease/teach',
          name: 'UserEducationTeach',
          component: UserEducationTeach
        },
        {
          path: '/user/educationRelease/kewu',
          name: 'UserEducationKewu',
          component: UserEducationKewu
        },
        {
          path: '/user/educationRelease/kejian',
          name: 'UserEducationKejian',
          component: UserEducationKejian
        },
        {
          path: '/user/educationRelease/order',
          name: 'UserEducationOrder',
          component: UserEducationOrder
        },
        {
          path: '/user/educationRelease/code',
          name: 'UserEducationCode',
          component: UserEducationCode
        },
        {
          path: '/user/educationRelease/userOrder',
          name: 'UserEducationUserOrder',
          component: UserEducationUserOrder
        }]
      }, {
        path: '/user/talentsRelease',
        name: 'TalentsRelease',
        component: TalentsRelease,
        redirect: '/user/talentsRelease/base',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/talentsRelease/base',
          name: 'UserTalentsBase',
          component: UserTalentsBase
        },
        {
          path: '/user/talentsRelease/detail',
          name: 'UserTalentsDetail',
          component: UserTalentsDetail
        },
        {
          path: '/user/talentsRelease/experience',
          name: 'UserTalentsExperienceList',
          component: UserTalentsExperienceList
        },
        {
          path: '/user/talentsRelease/position',
          name: 'UserTalentsPosition',
          component: UserTalentsPosition
        },
        {
          path: '/user/talentsRelease/receiveResume',
          name: 'UserTalentsReceiveResume',
          component: UserTalentsReceiveResume
        },
        {
          path: '/user/talentsRelease/sendResume',
          name: 'UserTalentsSendResume',
          component: UserTalentsSendResume
        },
        {
          path: '/user/talentsRelease/invitInterview',
          name: 'UserTalentsInvitInterview',
          component: UserTalentsInvitInterview
        },
        {
          path: '/user/talentsRelease/invitInterview2',
          name: 'UserTalentsInvitInterview2',
          component: UserTalentsInvitInterview2
        }]
      },
      {
        path: '/user/liveRelease',
        name: 'LiveRelease',
        component: LiveRelease,
        redirect: '/user/liveRelease/base',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/liveRelease/base',
          name: 'UserLiveBase',
          component: UserLiveBase
        },
        {
          path: '/user/liveRelease/liveInfo',
          name: 'UserLiveInfo',
          component: UserLiveInfo
        },
        {
          path: '/user/liveRelease/needInfo',
          name: 'UserNeedInfo',
          component: UserNeedInfo
        },
        {
          path: '/user/liveRelease/receiveResume',
          name: 'UserLiveReceiveResume',
          component: UserLiveReceiveResume
        },
        {
          path: '/user/liveRelease/sendResume',
          name: 'UserLiveSendResume',
          component: UserLiveSendResume
        }]
      },
      {
        path: '/user/ownRelease',
        name: 'OwnRelease',
        component: OwnRelease,
        redirect: '/user/ownRelease/base',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/ownRelease/base',
          name: 'UserOwnBase',
          component: UserOwnBase
        },
        {
          path: '/user/ownRelease/detail',
          name: 'UserOwnDetail',
          component: UserOwnDetail
        },
        {
          path: '/user/ownRelease/receivedMessage',
          name: 'UserOwnReceivedMessage',
          component: UserOwnReceivedMessage
        },
        {
          path: '/user/ownRelease/sendMessage',
          name: 'UserOwnSendMessage',
          component: UserOwnSendMessage
        },
        {
          path: '/user/ownRelease/comment',
          name: 'UserOwnComment',
          component: UserOwnComment
        },
        {
          path: '/user/ownRelease/report',
          name: 'UserOwnReport',
          component: UserOwnReport
        },
        {
          path: '/user/ownRelease/infoList',
          name: 'UserOwnInfoList',
          component: UserOwnInfoList
        }]
      }, {
        path: '/user/informationRelease',
        name: 'InformationRelease',
        component: InformationRelease,
        redirect: '/user/informationRelease/base',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/informationRelease/base',
          name: 'UserInformationBase',
          component: UserInformationBase
        },
        {
          path: '/user/informationRelease/receivedMessage',
          name: 'UserInformationReceivedMessage',
          component: UserInformationReceivedMessage
        },
        {
          path: '/user/informationRelease/service',
          name: 'UserInformationSerive',
          component: UserInformationSerive
        },
        {
          path: '/user/informationRelease/moduleList',
          name: 'UserInformationModuleList',
          component: UserInformationModuleList
        },
        {
          path: '/user/informationRelease/sendMessage',
          name: 'UserInformationSendMessage',
          component: UserInformationSendMessage
        },
        {
          path: '/user/informationRelease/comment',
          name: 'UserInformationComment',
          component: UserInformationComment
        },
        {
          path: '/user/informationRelease/report',
          name: 'UserInformationReport',
          component: UserInformationReport
        },
        {
          path: '/user/informationRelease/infoList',
          name: 'UserInformationInfoList',
          component: UserInformationInfoList
        }]
      },
      {
        path: '/user/sameRelease',
        name: 'SameRelease',
        component: SameRelease,
        redirect: '/user/sameRelease/base',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/sameRelease/base',
          name: 'UserSameBase',
          component: UserSameBase
        },
        {
          path: '/user/sameRelease/tongzhu',
          name: 'UserSameTongzhu',
          redirect: '/user/sameRelease/tongzhu/list',
          component: UserSameTongzhu,
          children: [
            {
              path: '/user/sameRelease/tongzhu/list',
              name: 'UserSameTongzhuList',
              component: UserSameTongzhuList
            },
            {
              path: '/user/sameRelease/tongzhu/memberlist',
              name: 'UserSameTongzhuMemberList',
              component: UserSameTongzhuMemberList
            },
            {
              path: '/user/sameRelease/tongzhu/zhiwenlist',
              name: 'UserSameZhiwenList',
              component: UserSameZhiwenList
            },
            {
              path: '/user/sameRelease/tongzhu/yitilist',
              name: 'UserSameYitiList',
              component: UserSameYitiList
            },
            {
              path: '/user/sameRelease/tongzhu/yitidetail',
              name: 'UserSameYitiDetail',
              component: UserSameYitiDetail
            },
            {
              path: '/user/sameRelease/tongzhu/tiyilist',
              name: 'UserSameTiyiList',
              component: UserSameTiyiList
            },
            {
              path: '/user/sameRelease/tongzhu/jianjie',
              name: 'UserSameJianjie',
              component: UserSameJianjie
            },
            {
              path: '/user/sameRelease/tongzhu/infolist',
              name: 'UserSameInfoList',
              component: UserSameInfoList
            },
            {
              path: '/user/sameRelease/tongzhu/infodetail',
              name: 'UserSameInfoDetail',
              component: UserSameInfoDetail
            },
            {
              path: '/user/sameRelease/tongzhu/tiebalist',
              name: 'UserSameTiebaList',
              component: UserSameTiebaList
            },
            {
              path: '/user/sameRelease/tongzhu/tiebadetail',
              name: 'UserSameTiebaDetail',
              component: UserSameTiebaDetail
            }
          ]
        },
        {
          path: '/user/sameRelease/tongguanList',
          name: 'UserSameTongguan',
          component: UserSameTongguan
        },
        {
          path: '/user/sameRelease/tongyuanList',
          name: 'UserSameTongyuan',
          component: UserSameTongyuan
        },
        {
          path: '/user/sameRelease/zuokeList',
          name: 'UserSameZuoke',
          redirect: '/user/sameRelease/zuokeList/base',
          component: UserSameZuoke,
          children: [
            {
              path: '/user/sameRelease/zuokeList/base',
              name: 'UserSameZuokeBase',
              component: UserSameZuokeBase
            },
            {
              path: '/user/sameRelease/zuokeList/list',
              name: 'UserSameZuokeList',
              component: UserSameZuokeList
            },
            {
              path: '/user/sameRelease/zuokeList/huida',
              name: 'UserSameZuokeHuida',
              component: UserSameZuokeHuida
            }
          ]
        }]
      },
      {
        path: '/user/logistics',
        name: 'UserLogistics',
        component: UserLogistics,
        meta: {
          title: '万知物流'
        },
        children: [
          {
            path: '/user/logistics/list',
            name: 'UserLogisticsList',
            meta: {
              requireLogin: true
            },
            component: UserLogisticsList
          },
          {
            path: '/user/logistics/edit/:id?',
            name: 'UserLogisticsEdit',
            meta: {
              requireLogin: true
            },
            component: UserLogisticsEdit
          }
        ]
      },
      {
        path: '/user/idle',
        name: 'UserIdle',
        component: UserIdle,
        meta: {
          title: '万知闲置'
        },
        children: [
          {
            path: '/user/idle/list',
            name: 'UserIdleList',
            meta: {
              requireLogin: true,
              title: '万知闲置'
            },
            component: UserIdleList
          },
          {
            path: '/user/idle/edit',
            name: 'UserIdleEdit',
            meta: {
              requireLogin: true,
              title: '万知闲置'
            },
            component: UserIdleEdit
          }
        ]
      },
      {
        path: '/user/house',
        name: 'UserHouse',
        component: UserHouse,
        meta: {
          title: '万知房产'
        },
        children: [
          {
            path: '/user/house/list/:sn/:tab',
            name: 'UserHouseList',
            meta: {
              requireLogin: true,
              title: '万知房产'
            },
            component: UserHouseList
          },
          {
            path: '/user/house/edit/:sn?/:tab?/:id?',
            name: 'UserHouseEdit',
            meta: {
              requireLogin: true,
              title: '万知房产'
            },
            component: UserHouseEdit
          }
        ]
      },
      {
        path: '/user/car',
        name: 'UserCar',
        component: UserCar,
        meta: {
          title: '万知车辆'
        },
        children: [
          {
            path: '/user/car/list/:sn/:tab',
            name: 'UserCarList',
            meta: {
              requireLogin: true,
              title: '万知车辆'
            },
            component: UserCarList
          },
          {
            path: '/user/car/edit/:sn?/:tab?/:id?',
            name: 'UserCarEdit',
            meta: {
              requireLogin: true,
              title: '万知车辆'
            },
            component: UserCarEdit
          }
        ]
      },
      {
        ...businessPersonCenter
      },
      {
        ...businessSellerCenter
      },
      {
        path: '/user/ship',
        name: 'UserShip',
        component: UserShip,
        meta: {
          title: '万知船舶'
        },
        children: [
          {
            path: '/user/ship/list/:sn/:tab',
            name: 'UserShipList',
            meta: {
              requireLogin: true,
              title: '万知船舶'
            },
            component: UserShipList
          },
          {
            path: '/user/ship/edit/:sn?/:tab?/:id?',
            name: 'UserShipEdit',
            meta: {
              requireLogin: true,
              title: '万知船舶'
            },
            component: UserShipEdit
          }
        ]
      },
      {
        path: '/user/personInfo',
        name: 'PersonInfo',
        component: PersonInfo,
        redirect: '/user/personInfo/base',
        meta: {
          requireLogin: true
        },
        children: [{
          path: '/user/personInfo/base',
          name: 'PersonInfoBase',
          component: PersonInfoBase
        },
        {
          path: '/user/personInfo/changePassword',
          name: 'ChangePassword',
          component: ChangePassword
        },
        {
          path: '/user/personInfo/childernAccount',
          name: 'ChildernAccount',
          component: ChildernAccount
        },
        {
          path: '/user/personInfo/cartManage',
          name: 'CartManage',
          component: CartManage
        },
        {
          path: '/user/personInfo/cartOrder',
          name: 'CartOrder',
          component: CartOrder

        }
        ]
      }]
    },
    {
      path: '/release',
      name: 'Release',
      component: Release,
      children: [{
        path: '/release/tour',
        name: 'ReleaseTour',
        component: ReleaseTour,
        meta: {
          requireLogin: true
        }
      }, {
        path: '/release/market',
        name: 'ReleaseMarket',
        component: ReleaseMarket,
        meta: {
          requireLogin: true
        }
      }, {
        path: '/release/education',
        name: 'ReleaseEducation',
        component: ReleaseEducation,
        meta: {
          requireLogin: true
        }
      }, {
        path: '/release/own',
        name: 'ReleaseOwn',
        component: ReleaseOwn,
        meta: {
          requireLogin: true
        }
      }, {
        path: '/release/information',
        name: 'ReleaseInformation',
        component: ReleaseInformation,
        meta: {
          requireLogin: true
        }
      }, {
        path: '/release/informationEdit',
        name: 'ReleaseInformationEdit',
        component: ReleaseInformationEdit,
        meta: {
          requireLogin: true
        }
      }, {
        path: '/release/talent',
        name: 'ReleaseTalents',
        component: ReleaseTalents,
        meta: {
          requireLogin: true
        }
      }, {
        path: '/release/live',
        name: 'ReleaseLive',
        component: ReleaseLive,
        meta: {
          requireLogin: true
        }
      }]
    },
    {
      path: '/Love',
      name: 'Love',
      component: Love,
      meta: {
        requireLogin: false,
        title: '【万知】万知万知，万万知，万知网里知万知；'
      }
    },
    {
      path: '/Introducerinfo',
      name: 'Introducerinfo',
      component: Introducerinfo
      // children: [{
      //   path: '/Love/MembershipDetails',
      //   name: 'MembershipDetails',
      //   component: MembershipDetails
      // }]
    },
    {
      path: '/Introducerinfogeren',
      name: 'Introducerinfogeren',
      component: Introducerinfogeren
      // children: [{
      //   path: '/Love/MembershipDetails',
      //   name: 'MembershipDetails',
      //   component: MembershipDetails
      // }]
    },
    {
      path: '/MembershipDetails',
      name: 'MembershipDetails',
      component: MembershipDetails
      // children: [{
      //   path: '/Love/MembershipDetails',
      //   name: 'MembershipDetails',
      //   component: MembershipDetails
      // }]
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment
    },
    {
      path: '/house',
      name: 'House',
      redirect: '/house/newfang/info/index',
      meta: {
        title: '万知房产'
      },
      component: House,
      children: [
        {
          path: ':sn/:tab/index',
          name: 'HouseIndex',
          meta: {
            title: '万知房产'
          },
          component: HouseIndex
        },
        {
          path: ':sn/:tab/detail/:id',
          name: 'HouseDetail',
          meta: {
            title: '万知房产'
          },
          component: HouseDetail
        },
        {
          path: ':sn/:tab/huxing/:id',
          name: 'HuxingDetail',
          meta: {
            title: '万知房产'
          },
          component: HuxingDetail
        }
      ]
    },
    {
      path: '/idle',
      name: 'Idle',
      redirect: '/idle/index',
      meta: {
        title: '万知闲置'
      },
      component: Idle,
      children: [
        {
          path: '/idle/index',
          name: 'IdleIndex',
          meta: {
            title: '万知闲置'
          },
          component: IdleIndex
        },
        {
          path: '/idle/detail',
          name: 'IdleDetail',
          meta: {
            title: '万知闲置'
          },
          component: IdleDetail
        }
      ]
    },
    {
      path: '/logistics',
      name: 'Logistics',
      redirect: '/logistics/index/qiyun/hy',
      meta: {
        title: '万知物流'
      },
      component: Logistics,
      children: [
        {
          path: '/logistics/index/:sn?/:tab?',
          name: 'LogisticsIndex',
          meta: {
            title: '万知物流'
          },
          component: LogisticsIndex
        },
        {
          path: '/logistics/detail/:sn?/:tab?/:id?',
          name: 'LogisticsDetail',
          meta: {
            title: '万知物流'
          },
          component: LogisticsDetail
        },
        {
          path: '/logistics/user/:id/:itemId?/:sn?/:tab?/',
          name: 'LogisticsUser',
          meta: {
            title: '万知物流'
          },
          component: LogisticsUser
        }
      ]
    },
    {
      ...carship
    },
    {
      ...business
    },
    {
      ...teacher
    },
    { path: '*', component: Page404 }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js